<template>
  <div>
    <el-dialog
      title="数据导出"
      v-model="dialogVisible"
      width="60%"
      :append-to-body="true"
      :before-close="handleClose"
    >
      <div class="progressTitle">
        <span v-if="percentage>=0 && percentage<100">数据导出中…</span>
        <span v-else-if="percentage<0">刚才网络好像开了会小差，请重试导出数据</span>
        <span v-else-if="percentage==100">数据导出成功</span>
      </div>
      <div class="progressCenter">
        <el-progress type="circle" :percentage="percentage" :color="colorFun()"></el-progress>
      </div>
      <div class="progressbottom">
        <template v-if="percentage>=0 && percentage<100">
          <el-button class="cancel" @click="handleClose">取消</el-button>
        </template>
        <template v-else-if="percentage==100">
          <el-button class="cancel" @click="handleClose">取消</el-button>
          <el-button class="sure" @click="load">下载excel</el-button>
        </template>
        <template v-else-if="percentage<0">
          <el-button class="sure" @click="secondLoad">重试</el-button>
        </template>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { filePreview } from '@/api/global.js';
export default {
  name: 'progresscesCpn',
  props: {
    //- draggable 是否可拖拽
    draggable: {
      type: Boolean,
      default: true
    },

  },
  data: function () {
    return {
      //- 
      dialogVisible: true,
      //- 进度值
      percentage: 0,
      //- 进度状态
      start: true,
      timer: null,
      downLoadUrl: '',
      index: 0,//- 序号
      datas: [],//- 数据
    }
  },
  mounted () {
    //- 设定定时器
    const that = this;
    this.timer = setInterval(() => {
      that.timerFun();
    }, 1000);

  },
  watch: {
  },
  unmounted () {
    //            清楚定时器
    clearInterval(this.timer)
  },
  methods: {
    //- 重试下载
    secondLoad () {
      const that = this;
      clearInterval(that.timer);
      that.downLoadUrl = '';
      that.percentage = 0;
      that.$parent.handle({
        status: 'upload',
        index: that.index,
        item: that.datas

      })
      this.timer = setInterval(() => {
        that.timerFun();
      }, 1000);

    },
    //- 提交下载
    load () {
      if (this.downLoadUrl != '') {
        filePreview({url:'/'+this.downLoadUrl},true)
        this.$parent.progressShow = false;
      }

    },
    //- 定时器
    timerFun () {
      let that = this;
      let percentage = parseInt(that.percentage);
      var random = '';
      console.log("定时器zouzhe")
      if (percentage >= 0 && percentage < 100) {
        console.log("定时器执行2222", that.start)
        if (that.start == true) {
          that.start = false;
          random = that.randomFun(0, 20);
        } else {
          if (100 - percentage <= 15) {
            // random = 100-percentage;
            that.percentage = 90;
            clearInterval(that.timer);
            that.timer = null;
            return;
          } else {
            if (percentage <= 50) {
              random = that.randomFun(0, (100 - percentage));
            } else if (percentage > 50 && percentage <= 70) {
              random = that.randomFun(0, 20);
            } else if (percentage > 70) {
              random = 85 - percentage;
            }

          }

        }
        that.percentage = percentage + random;
        // percentage += random;
      } else if (percentage > 100) {
        that.percentage = 100;
        console.log("结束定时器")
        clearInterval(that.timer);
        that.timer = null;

      }
    },
    //- 接口影响关闭定时器
    closeTimeFun (url) {
      this.downLoadUrl = url;
      this.percentage = 100;
      clearInterval(this.timer);
      this.timer = null;
    },
    //- 获得随机值
    randomFun (n, m) {
      let value = Math.floor(Math.random() * (m - n + 1) + n);
      return value
    },
    //- 关闭progress
    handleClose () {
      console.log("关闭");
      this.$parent.progressShow = false;

    },
    //- progress状态颜色
    colorFun () {
      let percentage = parseInt(this.percentage);
      let color = '';
      if (percentage < 100) {
        color = '#ECD3B2'
      } else if (percentage == 100) {
        color = '#3FAF67'

      } else if (percentage < 0) {
        color = '#D44C4C'

      }
      return color

    }

  }
}
</script>
<style lang="scss" scoped>
.progressTitle {
  width: 100%;
  height: 24px;
  line-height: 24px;
  font-size: 18px;
  color: rgba(0, 0, 0, 1);
  text-align: center;
  margin: 20px 0;
}
.progressCenter {
  text-align: center;
  margin: 15px 0;
}
.progressbottom {
  text-align: center;
  margin-top: 29px;
  .sure {
    background: #19b359;
    color: #333333;
    border-color: #19b359;
  }
  .cancel {
    background: white;
    color: #999999;
    border-color: #999999;
  }
}
</style>
